import { z } from 'zod';
import { SalesTotalSchema } from './sales-total';

// form validation rules
export const YearSalesSchema = z.object({
  year: z.number(),
  totals: SalesTotalSchema,
  totals_to_date: SalesTotalSchema,
  totals_to_date_month: SalesTotalSchema,
  // `Monthly [12]SalesStats` is a fixed-size Go array, never nil, so this one
  // needs no zGoSlice — it always marshals as twelve entries.
  monthly: z.array(SalesTotalSchema),
});

export type YearSales = z.infer<typeof YearSalesSchema>;
